module.exports = __webpack_public_path__ + "static/media/capstone_permissions.32e6574b.yaml";